<header-bar></header-bar>
<router-outlet></router-outlet>
<version-bar></version-bar>
